import { CreateApiResponse, FetchApiResponse, FilterMetadata } from "redux/types";

export enum RepaymentInstrumentBulkRequestType {
    CREATE_REPAYMENT_INSTRUMENT_BULK_REQUEST = "@@auth/CREATE_REPAYMENT_INSTRUMENT_BULK_REQUEST",
    CREATE_REPAYMENT_INSTRUMENT_BULK_REQUEST_SUCCESS = "@@auth/CREATE_REPAYMENT_INSTRUMENT_BULK_REQUEST_SUCCESS",
    CREATE_REPAYMENT_INSTRUMENT_BULK_REQUEST_ERROR = "@@auth/CREATE_REPAYMENT_INSTRUMENT_BULK_REQUEST_ERROR",
    RESET_CREATE_REPAYMENT_INSTRUMENT_BULK_REQUEST = "@@auth/RESET_CREATE_REPAYMENT_INSTRUMENT_BULK_REQUEST",

    FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST = "@@auth/FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST",
    FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SUCCESS = "@@auth/FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SUCCESS",
    FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_ERROR = "@@auth/FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_ERROR",
    RESET_FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST = "@@auth/RESET_FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST",

    FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_DETAIL = "@@auth/FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_DETAIL",
    FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_DETAIL_SUCCESS = "@@auth/FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_DETAIL_SUCCESS",
    FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_DETAIL_ERROR = "@@auth/FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_DETAIL_ERROR",
    RESET_FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_DETAIL = "@@auth/RESET_FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_DETAIL",

    FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_VERSION = "@@auth/FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_VERSION",
    FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_VERSION_SUCCESS = "@@auth/FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_VERSION_SUCCESS",
    FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_VERSION_ERROR = "@@auth/FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_VERSION_ERROR",
    RESET_FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_VERSION = "@@auth/RESET_FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_VERSION",

    FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_FILTERS = "@@auth/FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_FILTERS",
    FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_FILTERS_SUCCESS = "@@auth/FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_FILTERS_SUCCESS",
    FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_FILTERS_ERROR = "@@auth/FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_FILTERS_ERROR",

    APPROVE_REPAYMENT_INSTRUMENT_BULK_REQUEST = "@@auth/APPROVE_REPAYMENT_INSTRUMENT_BULK_REQUEST",
    APPROVE_REPAYMENT_INSTRUMENT_BULK_REQUEST_SUCCESS = "@@auth/APPROVE_REPAYMENT_INSTRUMENT_BULK_REQUEST_SUCCESS",
    APPROVE_REPAYMENT_INSTRUMENT_BULK_REQUEST_ERROR = "@@auth/APPROVE_REPAYMENT_INSTRUMENT_BULK_REQUEST_ERROR",
    RESET_APPROVE_REPAYMENT_INSTRUMENT_BULK_REQUEST = "@@auth/RESET_APPROVE_REPAYMENT_INSTRUMENT_BULK_REQUEST",

    REJECT_REPAYMENT_INSTRUMENT_BULK_REQUEST = "@@auth/REJECT_REPAYMENT_INSTRUMENT_BULK_REQUEST",
    REJECT_REPAYMENT_INSTRUMENT_BULK_REQUEST_SUCCESS = "@@auth/REJECT_REPAYMENT_INSTRUMENT_BULK_REQUEST_SUCCESS",
    REJECT_REPAYMENT_INSTRUMENT_BULK_REQUEST_ERROR = "@@auth/REJECT_REPAYMENT_INSTRUMENT_BULK_REQUEST_ERROR",
    RESET_REJECT_REPAYMENT_INSTRUMENT_BULK_REQUEST = "@@auth/RESET_REJECT_REPAYMENT_INSTRUMENT_BULK_REQUEST",

    FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SETTLED_ENTRIES = "@@auth/FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SETTLED_ENTRIES",
    FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SETTLED_ENTRIES_SUCCESS = "@@auth/FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SETTLED_ENTRIES_SUCCESS",
    FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SETTLED_ENTRIES_ERROR = "@@auth/FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SETTLED_ENTRIES_ERROR",
    RESET_FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SETTLED_ENTRIES = "@@auth/RESET_FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SETTLED_ENTRIES",


    FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SETTLED_ENTRIES_DETAIL = "@@auth/FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SETTLED_ENTRIES_DETAIL",
    FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SETTLED_ENTRIES_DETAIL_SUCCESS = "@@auth/FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SETTLED_ENTRIES_DETAIL_SUCCESS",
    FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SETTLED_ENTRIES_DETAIL_ERROR = "@@auth/FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SETTLED_ENTRIES_DETAIL_ERROR",
    RESET_FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SETTLED_ENTRIES_DETAIL = "@@auth/RESET_FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SETTLED_ENTRIES_DETAIL",

    REVIEW_REPAYMENT_INSTRUMENT_BULK_REQUEST = "@@auth/REVIEW_REPAYMENT_INSTRUMENT_BULK_REQUEST",
    REVIEW_REPAYMENT_INSTRUMENT_BULK_REQUEST_SUCCESS = "@@auth/REVIEW_REPAYMENT_INSTRUMENT_BULK_REQUEST_SUCCESS",
    REVIEW_REPAYMENT_INSTRUMENT_BULK_REQUEST_ERROR = "@@auth/REVIEW_REPAYMENT_INSTRUMENT_BULK_REQUEST_ERROR",
    RESET_REVIEW_REPAYMENT_INSTRUMENT_BULK_REQUEST = "@@auth/RESET_REVIEW_REPAYMENT_INSTRUMENT_BULK_REQUEST",

    FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_AUDIT = "@@auth/FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_AUDIT",
    FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_AUDIT_SUCCESS = "@@auth/FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_AUDIT_SUCCESS",
    FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_AUDIT_ERROR = "@@auth/FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_AUDIT_ERROR",
    RESET_FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_AUDIT = "@@auth/RESET_FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_AUDIT",


    RESET = "@@auth/RESET", //general reset
};

export type RepaymentInstrumentBulkRequestActionDispatch = {
    type:
    | RepaymentInstrumentBulkRequestType.CREATE_REPAYMENT_INSTRUMENT_BULK_REQUEST
    | RepaymentInstrumentBulkRequestType.RESET_CREATE_REPAYMENT_INSTRUMENT_BULK_REQUEST

    | RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST
    | RepaymentInstrumentBulkRequestType.RESET_FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST

    | RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_DETAIL
    | RepaymentInstrumentBulkRequestType.RESET_FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_DETAIL

    | RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_VERSION
    | RepaymentInstrumentBulkRequestType.RESET_FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_VERSION

    | RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_FILTERS

    | RepaymentInstrumentBulkRequestType.APPROVE_REPAYMENT_INSTRUMENT_BULK_REQUEST
    | RepaymentInstrumentBulkRequestType.RESET_APPROVE_REPAYMENT_INSTRUMENT_BULK_REQUEST

    | RepaymentInstrumentBulkRequestType.REJECT_REPAYMENT_INSTRUMENT_BULK_REQUEST
    | RepaymentInstrumentBulkRequestType.RESET_REJECT_REPAYMENT_INSTRUMENT_BULK_REQUEST

    | RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SETTLED_ENTRIES
    | RepaymentInstrumentBulkRequestType.RESET_FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SETTLED_ENTRIES

    | RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SETTLED_ENTRIES_DETAIL
    | RepaymentInstrumentBulkRequestType.RESET_FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SETTLED_ENTRIES_DETAIL

    | RepaymentInstrumentBulkRequestType.REVIEW_REPAYMENT_INSTRUMENT_BULK_REQUEST
    | RepaymentInstrumentBulkRequestType.RESET_REVIEW_REPAYMENT_INSTRUMENT_BULK_REQUEST

    | RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_AUDIT
    | RepaymentInstrumentBulkRequestType.RESET_FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_AUDIT

    | RepaymentInstrumentBulkRequestType.RESET
    payload: any;
};

export type RepaymentInstrumentBulkRequestReducerDispatch = {
    type:
    | RepaymentInstrumentBulkRequestType.CREATE_REPAYMENT_INSTRUMENT_BULK_REQUEST
    | RepaymentInstrumentBulkRequestType.CREATE_REPAYMENT_INSTRUMENT_BULK_REQUEST_SUCCESS
    | RepaymentInstrumentBulkRequestType.CREATE_REPAYMENT_INSTRUMENT_BULK_REQUEST_ERROR
    | RepaymentInstrumentBulkRequestType.RESET_CREATE_REPAYMENT_INSTRUMENT_BULK_REQUEST

    | RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST
    | RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SUCCESS
    | RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_ERROR
    | RepaymentInstrumentBulkRequestType.RESET_FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST

    | RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_DETAIL
    | RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_DETAIL_SUCCESS
    | RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_DETAIL_ERROR
    | RepaymentInstrumentBulkRequestType.RESET_FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_DETAIL

    | RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_VERSION
    | RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_VERSION_SUCCESS
    | RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_VERSION_ERROR
    | RepaymentInstrumentBulkRequestType.RESET_FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_VERSION

    | RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_FILTERS
    | RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_FILTERS_SUCCESS
    | RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_FILTERS_ERROR

    | RepaymentInstrumentBulkRequestType.APPROVE_REPAYMENT_INSTRUMENT_BULK_REQUEST
    | RepaymentInstrumentBulkRequestType.APPROVE_REPAYMENT_INSTRUMENT_BULK_REQUEST_SUCCESS
    | RepaymentInstrumentBulkRequestType.APPROVE_REPAYMENT_INSTRUMENT_BULK_REQUEST_ERROR
    | RepaymentInstrumentBulkRequestType.RESET_APPROVE_REPAYMENT_INSTRUMENT_BULK_REQUEST

    | RepaymentInstrumentBulkRequestType.REJECT_REPAYMENT_INSTRUMENT_BULK_REQUEST
    | RepaymentInstrumentBulkRequestType.REJECT_REPAYMENT_INSTRUMENT_BULK_REQUEST_SUCCESS
    | RepaymentInstrumentBulkRequestType.REJECT_REPAYMENT_INSTRUMENT_BULK_REQUEST_ERROR
    | RepaymentInstrumentBulkRequestType.RESET_REJECT_REPAYMENT_INSTRUMENT_BULK_REQUEST

    | RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SETTLED_ENTRIES
    | RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SETTLED_ENTRIES_SUCCESS
    | RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SETTLED_ENTRIES_ERROR
    | RepaymentInstrumentBulkRequestType.RESET_FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SETTLED_ENTRIES

    | RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SETTLED_ENTRIES_DETAIL
    | RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SETTLED_ENTRIES_DETAIL_SUCCESS
    | RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SETTLED_ENTRIES_DETAIL_ERROR
    | RepaymentInstrumentBulkRequestType.RESET_FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SETTLED_ENTRIES_DETAIL

    | RepaymentInstrumentBulkRequestType.REVIEW_REPAYMENT_INSTRUMENT_BULK_REQUEST
    | RepaymentInstrumentBulkRequestType.REVIEW_REPAYMENT_INSTRUMENT_BULK_REQUEST_SUCCESS
    | RepaymentInstrumentBulkRequestType.REVIEW_REPAYMENT_INSTRUMENT_BULK_REQUEST_ERROR
    | RepaymentInstrumentBulkRequestType.RESET_REVIEW_REPAYMENT_INSTRUMENT_BULK_REQUEST

    | RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_AUDIT
    | RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_AUDIT_SUCCESS
    | RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_AUDIT_ERROR
    | RepaymentInstrumentBulkRequestType.RESET_FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_AUDIT


    | RepaymentInstrumentBulkRequestType.RESET;

    payload: {
        data?: FetchApiResponse<BulkRepayment>;
        error?: string;
    }
}

export type BulkRepayment = {
    accountNumber: string;
    amount: number | null;
    externalId: string;
    errorText: string;
    status: string;
    borrowerExternalId : string,
    computedProgramExternalId : string,
    borrowerName: string,
    programmeName: string,
};

export type BulkRepaymentVersionType = {
    isFirstRecord: boolean;
    status: string;
    stagingBatchActionType: string;
    repaymentSettlementStrategy: string,
    isReviewed: boolean
};

//use in action
export type CheckerRemark = {
    checkerRemarks: string;
    externalId: string;
}
export type GetSingleRecordById = {
    externalId: string | undefined;
}

export type reviewBulkRepaymentPayload = {
    isReviewed: boolean;
}
export type reviewBulkRepayment = {
    versionRecordId: any,
    reviewPayload: reviewBulkRepaymentPayload
}

//use in saga
export type CreateRepaymentBulkIntrument = {
    payload: any; //may change
    type: string;
};
export type FetchRepaymentIntrumentBulkRequest = {
    payload: FilterMetadata;
    type: string;
};
export type FetchSingleRepaymentIntrumentBulkRequestInfo = {
    payload: GetSingleRecordById;
    type: string;
};

//used in reducer 
export type RepaymentBulkIntrumentReduxStateWithoutListObject = {
    loading?: boolean;
    data?: CreateApiResponse<BulkRepayment>;
    error?: string | null;
};
export type RepaymentBulkIntrumentReduxStateWithListObject = {
    loading?: boolean;
    data?: FetchApiResponse<BulkRepayment>;
    error?: string | null;
};
